<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <div>
          <div class="headline">{{ title }}</div>
        </div>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="!savable"
          @click="save"
          v-permit.SHARP_DIL_WH_SETTING_SAVE
          >{{ $t('app.buttons.save') }}</v-btn
        >
        <v-btn @click="back">{{ $t('app.buttons.back') }}</v-btn>
      </v-card-actions>
    </v-card>

    <v-card class="mt-2">
      <v-form class="static">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                label="D/O NO"
                v-model="detail.doNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                label="納入指示者"
                v-model="detail.deliveryDirectorName1"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                label="コンテナNO"
                v-model="detail.containerNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                label="運送形態"
                v-model="detail.transportModeCode"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.partner')"
                v-model="detail.partnerName"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.dischargePort')"
                v-model="detail.dischargePortName"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.etd')"
                v-model="detail.etd"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.eta')"
                v-model="detail.eta"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.blNo')"
                v-model="detail.blNo"
              ></v-text-field>
            </v-flex>
            <v-flex md3 xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.shippingAdvice.blIssueDate')"
                v-model="detail.blIssueDate"
              ></v-text-field>
            </v-flex>
            <v-flex md3 v-if="isSea" xs12>
              <v-text-field
                :disabled="true"
                :label="$t('app.labels.shipName')"
                v-model="detail.shipName"
              ></v-text-field>
            </v-flex>

            <v-flex md3 v-if="isAir" xs12>
              <v-text-field
                :disabled="true"
                :label="$t('B0400.labels.flightNo')"
                v-model="detail.volNo"
              ></v-text-field>
            </v-flex>
            <v-flex v-if="isMe">
              <v-btn @click="editLogisticsSku()">物流社内品番明細 </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md6 sm6 xs12>
              <div required>
                <remote-autocomplete
                  :disabled="true"
                  :rules="[(v) => !!v || 'SJL納入場所 is required']"
                  label="SJL納入場所"
                  url="warehouses/kv"
                  v-model="detail.sjlWarehouseId"
                ></remote-autocomplete>
              </div>
            </v-flex>
            <v-flex md6 sm6 xs12>
              <div required>
                <remote-autocomplete
                  :rules="[(v) => !!v || '最终納入場所 is required']"
                  @change="clearPattern"
                  label="最终納入場所"
                  url="warehouses/sjl-kv"
                  v-model="detail.finallyWarehouseId"
                ></remote-autocomplete>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md6 sm6 xs12>
              <div required>
                <date-picker
                  :rules="[(v) => !!v || '納入予定日 is required']"
                  label="納入予定日"
                  v-model="detail.forecastDeliveryDate"
                ></date-picker>
              </div>
            </v-flex>
            <v-flex md6 sm6 xs12>
              <div required>
                <v-text-field
                  :rules="[
                    (v) =>
                      /^(((0|1)\d)|(2[0-3]))[0-5][0-9]$/.test(v) ||
                      `4桁の数の有効時間を入力してください`,
                  ]"
                  label="時間"
                  v-model="detail.forecastDeliveryTime"
                />
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <logistics-sku-detail ref="logistics"></logistics-sku-detail>
    <long-distance-dialog ref="longDistanceDialog"></long-distance-dialog>
  </v-container>
</template>

<script>
import LogisticsSkuDetail from '../B0600/LogisticsSkuDetail.vue'
import LongDistanceDialog from '../B2300/LongDistanceDialog'
import DateFormat from 'dateformat'

export default {
  components: {
    LogisticsSkuDetail,
    LongDistanceDialog,
  },
  data() {
    return {
      valid: false,
      title: '納入場所指定',
      routingItem: {},
      dialog: {
        show: false,
      },
      detailHeaders: [
        {
          label: 'D/O NO',
          field: 'doNo',
        },
        {
          label: '納入指示者',
          field: '',
        },
        {
          label: 'コンテナNO',
          field: 'containerNo',
        },
        {
          label: '運送形態',
          field: 'transportModeCode',
        },
        {
          label: '海外取引先',
          field: 'partnerName',
        },
        {
          label: '陸揚港',
          field: 'dischargePortCode',
        },
        {
          label: 'ETD',
          field: 'etd',
        },
        {
          label: 'ETA',
          field: 'eta',
        },
        {
          label: 'B/L NO',
          field: 'blNo',
        },
        {
          label: 'B/L発行日',
          field: 'blIssueDate',
        },
        {
          label: '本船名',
          field: 'shipName',
        },
      ],
      detail: {},
      errors: {
        SHIPMENT_HAS_CHANGED:
          '当該データのステータスは更新されたため、画面更新してからもう一度お試してください。',
      },
    }
  },
  methods: {
    editLogisticsSku() {
      this.$refs.logistics.popup(this.detail.packages)
    },
    containerNo(item) {
      if (item.packages != null) {
        if (item.packages.filter((p) => p.containerNo != null).length > 0) {
          return item.packages.filter((p) => p.containerNo != null)[0]
            .containerNo
        }
      }
    },
    load() {
      this.$http
        .get(`/delivery-orders/${this.$route.query.id}/get-nearly-date`)
        .then((res) => {
          var initDate = res.data
          this.$http
            .get(`/shipping-advices/${this.$route.query.id}`)
            .then((res) => {
              this.detail = res.data
              this.detail.containerNo = this.containerNo(this.detail)
              if (this.detail.forecastDeliveryDate === null) {
                this.detail.forecastDeliveryDate = initDate
              }
              this.detail.forecastDeliveryTime =
                this.detail.forecastDeliveryTime &&
                [
                  this.detail.forecastDeliveryTime.slice(0, 2),
                  this.detail.forecastDeliveryTime.slice(3, 5),
                ].join('')
            })
            .catch((err) => {
              return Promise.reject(err)
            })
        })
    },
    back() {
      this.$router.push('/B0600')
    },
    returnToList() {
      this.$message('', '保存済')
      this.$router.push('/B0600')
    },
    getConfigStatus() {
      return {}
    },
    save() {
      var eta = this.detail.eta
      var forecastDeliveryDate = this.detail.forecastDeliveryDate
      if (this.$daysBetween(eta, forecastDeliveryDate) > 30) {
        this.$confirm({
          content: 'ＥＴＡから３０日以上経過していますので、確認ください',
          action: 'そのまま保存',
          rejectAction: 'キャンセル',
        })
          .then(() => {
            this.doSave()
          })
          .catch(() => {
            return
          })
      } else {
        this.doSave()
      }
    },

    doSave() {
      var id = this.detail.id
      this.$http
        .get(
          `/warehouse-container-settings/check-if-long-distance-route/shipment/${id}/warehouse/${
            this.detail.finallyWarehouseId
          }`
        )
        .then((res) => {
          if (res.data) {
            this.$refs.longDistanceDialog.popup(
              this.detail,
              this.today,
              'B0600'
            )
          } else {
            var time = this.$insert(this.detail.forecastDeliveryTime, 0, 2, ':')
            time = this.$insert(time, 0, 5, ':')
            time = time + '00'
            this.$http
              .put(
                `/delivery-orders/${this.detail.id}/updateInfo?version=${
                  this.detail.version
                }`,
                {
                  finallyWarehouseId: this.detail.finallyWarehouseId,
                  forecastDeliveryDate: this.detail.forecastDeliveryDate,
                  forecastDeliveryTime: time,
                }
              )
              .then(() => {
                this.send(id)
              })
              .catch((res) => {
                this.$showError(res)
              })
          }
        })
    },

    send(id) {
      return this.$http
        .put(`/delivery-orders/${id}/send-email-date`)
        .then(() => {
          this.$message('', '納入指示済')
          this.$router.go(-1)
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    clearPattern() {
      this.detail.deliveryPatternCode = null
      this.detail.routes = [
        {
          label: 'A配送業者',
          seq: 1,
        },
        {
          label: 'B配送業者',
          seq: 2,
        },
      ]
    },
    reUsePattern() {
      if (
        this.detail.reUsed === true &&
        this.detail.shipmentType === 'FORMALSA'
      ) {
        this.$http.get(
          `/shipping-advices/${this.$route.query.id}/reuse-pattern`
        )
      }
    },
  },
  mounted() {
    this.load()
  },
  computed: {
    time() {
      var time = this.$insert(this.detail.forecastDeliveryTime, 0, 2, ':')
      time = this.$insert(time, 0, 5, ':')
      return (time = time + '00')
    },
    savable() {
      return (
        this.valid &&
        (this.detail.status === '指示Mail送信済' ||
          this.detail.status === 'SJL送信済' ||
          this.detail.status === 'SA一時保存-SJL' ||
          this.detail.status === '事前納入指示Mail送信済')
      )
    },
    isSea() {
      return this.$isSea(this.detail.transportModeId)
    },
    isAir() {
      return this.$isAir(this.detail.transportModeId)
    },
    isMe() {
      return this.detail.headquarterCode === 'ME'
    },
    today() {
      return DateFormat(new Date(), 'yyyy-mm-dd')
    },
  },
  watch: {
    'detail.finallyWarehouseId'() {
      if (this.detail.finallyWarehouseId != null) {
        this.$http
          .get(
            `/delivery-orders/${
              this.detail.finallyWarehouseId
            }/change-sjlWarehouse`
          )
          .then((res) => {
            this.$set(this.detail, 'sjlWarehouseId', res.data.id)
          })
      }
    },
  },
}
</script>
